import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Data } from '@angular/router';
import { MmtSiteCoords } from 'src/app/models/mmt.model';
import { MapMarker, MapInfoWindow } from '@angular/google-maps';

@Component({
  selector: 'app-mmt-map',
  templateUrl: './mmt-map.component.html',
  styleUrls: ['./mmt-map.component.scss']
})
export class MmtMapComponent implements OnInit {

  @ViewChild(MapInfoWindow, { static: false }) info: MapInfoWindow

  sites: MmtSiteCoords[] = [];
  selectedSite: MmtSiteCoords = {name: '', coords: {lat:0,lng:0}};
  zoom = 7;
  center = {
      lat: 52.561928,
      lng: -1.464854,
    };

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: Data) => {
      this.sites = data.sites;
      console.log(this.sites);
    });
  }

  showInfo(marker: MapMarker, site: MmtSiteCoords) {

    if (site.name != this.selectedSite.name) {
      this.selectedSite = { ...site };
      this.info.open();
    } else {
      this.selectedSite.name = '';
    }

  }

  onInfoClosed() {
    this.info.close();
    this.selectedSite.name = '';
  }
}
